import Mail from "assets/images/Mail.png";
import BftButton from "common/components/button";
import BftInput from "common/components/input";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

interface Props {
	show: boolean;
	email: string;
	idSoggetto?: string;
	onClose: () => void;
	onConfirm: (e: any) => void;
}

const InvitoModal = (props: Props) => {
	const { show, email, idSoggetto, onClose, onConfirm } = props;
	const [invitationData, setInvitationData] = useState({
		email,
		reason: "",
		idSoggetto,
	});

	useEffect(() => {
		setInvitationData({
			...invitationData,
			email: email,
			idSoggetto: idSoggetto,
		});
	}, [email, idSoggetto]);

	const handleChange = (name: string) => (event: any) => {
		setInvitationData({ ...invitationData, [name]: event.target.value });
	};

	const handleSubmit = () => {
		onConfirm(invitationData);
		setInvitationData({
			email: "",
			reason: "",
			idSoggetto: "",
		});
	};

	const getMessageModal = () => {
		return (
			<>
				Sarà inviata un' e-mail contente l'invito all' indirizzo&nbsp;
				<span className="font-weigth-bold m-0">{invitationData.email || email}</span>.
			</>
		);
	};

	return (
		<Modal show={show} backdrop="static" onHide={onClose} keyboard={false}>
			<Modal.Header closeButton></Modal.Header>
			<div
				className="d-flex justify-content-center"
				style={{
					borderRadius: "100%",
					borderTopLeftRadius: "0%",
					borderTopRightRadius: "0%",
					borderStyle: "solid",
					backgroundColor: "#EBF4FE",
					border: "0px",
					width: "auto",
					height: "auto",
				}}
			>
				<img src={Mail} className="w-75 mb-1"></img>
			</div>

			<div className="d-flex align-items-center flex-column">
				<h5 className="mt-3 mb-0">Manda un invito</h5>
			</div>
			<Modal.Body>
				<div className="container mb-3">{getMessageModal()}</div>

				<BftInput
					required
					type={"email"}
					name={"email"}
					placeholder={"Email*"}
					value={invitationData.email}
					onChange={handleChange("email")}
				/>
				<BftInput
					required
					type={"text"}
					name={"testoFacoltativo"}
					placeholder={"Testo facoltativo"}
					as={"textarea"}
					inputStyle={{ minHeight: "100px" }}
					value={invitationData.reason}
					onChange={handleChange("reason")}
				/>
			</Modal.Body>
			<Modal.Footer className="justify-content-center">
				<BftButton
					className="btn-buffetti col-12 ml-auto"
					onClick={() => handleSubmit()}
					isDisabled={invitationData.email.length === 0}
				>
					Invia invito
				</BftButton>
			</Modal.Footer>
		</Modal>
	);
};

export default InvitoModal;
